// import React, { useState } from 'react';
import scale from '../images/scalable.png';
import bar from '../images/reduction.png';
import bar1 from '../images/bar1.png';
import seam from '../images/seamless.png';
import robut from '../images/recycle.png';
import Collabarators from '../images/collabration.png';
import Rt from '../images/Rt.png';
import cs from '../images/CS pencil.png';
import security1 from '../images/secuity1.png';
import security from '../images/security.png';
import { useNavigate } from 'react-router-dom';


const KeyFeatures = () => {

    const Icons = {
    BrainAI: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 2a4 4 0 0 0-4 4v1H7a3 3 0 0 0-3 3v4a3 3 0 0 0 3 3h1v1a4 4 0 0 0 8 0v-1h1a3 3 0 0 0 3-3v-4a3 3 0 0 0-3-3h-1V6a4 4 0 0 0-4-4z"/>
          <path d="M9 10h1"/>
          <path d="M9 14h1"/>
          <path d="M14 10h1"/>
          <path d="M14 14h1"/>
          <path d="M12 18v-4"/>
          <path d="M12 10V6"/>
          <path d="M10 10h4"/>
        </svg>
      ),
      Pill: () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"/>
          <path d="m8.5 8.5 7 7"/>
        </svg>
      ), Funnel: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polygon points="3 4 21 4 14 12 14 19 10 19 10 12 3 4" />
        </svg>
      ),
  Flask: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 2v7.31"/>
      <path d="M14 9.3V2"/>
      <path d="M8.5 2h7"/>
      <path d="M14 9.3a6.5 6.5 0 1 1-4 0"/>
      <path d="M5.52 16h12.96"/>
    </svg>
  ),
  GitFork: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="18" r="3"/>
      <circle cx="6" cy="6" r="3"/>
      <circle cx="18" cy="6" r="3"/>
      <path d="M18 9v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9"/>
      <path d="M12 12v3"/>
    </svg>
  ),
  Search: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"/>
      <path d="m21 21-4.3-4.3"/>
    </svg>
  ),
  ShieldTick: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Shield Shape */}
      <path d="M12 2L3 6v6c0 5 3.8 9 9 10 5.2-1 9-5 9-10V6l-9-4z" />
      {/* Tick Mark Inside Shield */}
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),
  ArrowRight: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </svg>
  )
};
  //  const [animatedItems, setAnimatedItems] = useState([]);
        const navigate = useNavigate();
  const features = [
    { title: "Scalable Architecture", icon: scale },
    { title: "High Performance", icon: bar1 },
    { title: "Seamless Integrations", icon: seam },
    { title: "Robust Security & Compliance", icon: security1 },
    { title: "Customizable Solutions", icon: cs },
    { title: "Collaborative Workbench", icon: Collabarators },
    { title: "Drug Likeliness & Rapid DMTA iteration", icon: robut },
    { title: "5x Reduced Cost & Time", icon: bar },
    { title: "Real-time Experiment Validation", icon: Rt },
    { title: "Safety (30+ PK/ADMET end)", icon: security },
  ];

  return (
    <div className="bg-black text-white py-12 px-4 sm:px-8 lg:px-24 xl:px-32 font-sofia">

<p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-gray-300 mx-auto mb-12 text-center">
  Key Features and Benefits
</p>


      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
        {features.map((feature, index) => (
          <div
            key={index}
            className="p-4 rounded-2xl  flex flex-col items-center  h-[160px]"
          >
            <img
              src={feature.icon}
              alt={feature.title}
              className="h-16 w-16 mb-3 object-contain"
            />
            <h3 className="text-lg text-[#C9C9C9] text-center font-medium leading-snug">
              {feature.title}
            </h3>
          </div>
       
        ))}
    
       
      </div>
      <div className=' mt-6 flex items-center text-center justify-center'>
 <button
            onClick={() => navigate('/contact')}
            className="relative bg-gradient-to-r from-[#6FC5F0] to-[#4A90E2] item-center flex hover:from-[#4A90E2] hover:to-[#6FC5F0] text-white font-semibold py-3 px-6 sm:px-8 rounded-full transition-all duration-500 transform hover:scale-105 active:scale-95 flex items-center group"
          >
        
            <span className='text-xl text-black font-bold'>Request Platform Demo</span>
            <span className="ml-2 text-black transition-transform duration-500 transform group-hover:translate-x-1">
              <Icons.ArrowRight />
            </span>
            <div className="absolute inset-0 bg-white rounded-full opacity-0 transition-opacity duration-300 group-hover:opacity-10"></div>
          </button>
      </div>
      
    </div>
  );
};

export default KeyFeatures;
